module.exports = __webpack_public_path__ + "static/media/muli-webfont.2a6b8631.woff2";